import React from 'react';
import PropTypes from 'prop-types';

import ActivityLogRow from './ActivityLogRow';

import './scss/activityLog.scss';

const ActivityLog = ({ logs }) => (
  <div className="activity-log">
    <div className="title">History</div>

    { logs.length > 0 ? (
      <table>
        <tbody>
          { logs.map((log, index, allLogs) => {
            let isNewSession = false;

            if (index === 0 || allLogs[index - 1].QbSessionId !== log.QbSessionId) {
              isNewSession = true;
            }

            return (
              <ActivityLogRow
                key={ index }
                isNewSession={ isNewSession }
                stamp={ new Date(log.Stamp) }
                text={ log.Value }
              />
            );
          }) }
        </tbody>
      </table>
    ) : (
      <div className="no-history">
        <em>There is no history to display.</em>
      </div>) }
  </div>
);

ActivityLog.propTypes = {
  logs: PropTypes.arrayOf(PropTypes.shape({
    QbSessionId: PropTypes.any,
    Stamp: PropTypes.any,
    Value: PropTypes.string,
  })).isRequired,
};

export default ActivityLog;



// WEBPACK FOOTER //
// ./src/components/Status/components/SyncPanel/components/ActivityLog.js